import { translate } from '../../utils';
import { PortfolioSummaryCard } from './PortfolioSummaryCard';

/** @param {{ portfolioSummary: import('./portfolioDashboard.types').PortfolioSummary }} props */
export const PortfolioSummary = function PortfolioSummary({ portfolioSummary }) {
    return (
        <div className="grid mb-3">
            <PortfolioSummaryCard
                count={portfolioSummary.hotelCount}
                label={translate('frontend', 'PORTFOLIO_DASHBOARD_HOTELS', { count: portfolioSummary.hotelCount })}
                icon="fa fa-building"
            />
            <PortfolioSummaryCard
                count={portfolioSummary.roomCount}
                label={translate('frontend', 'PORTFOLIO_DASHBOARD_ROOMS', { count: portfolioSummary.roomCount })}
                icon="fa fa-door-closed"
            />
            <PortfolioSummaryCard
                count={portfolioSummary.bedCount}
                label={translate('frontend', 'PORTFOLIO_DASHBOARD_BEDS', { count: portfolioSummary.bedCount })}
                icon="fa fa-bed"
            />
            <PortfolioSummaryCard
                count={portfolioSummary.cityCount}
                label={translate('frontend', 'PORTFOLIO_DASHBOARD_CITIES', { count: portfolioSummary.cityCount })}
                icon="fa fa-city"
            />
        </div>
    );
}
